import React, { useEffect, useState } from "react";
import {
  getRequest,
  postRequest,
} from "../../../../../../services/api/apiService";
import { toast } from "react-toastify";

const ConnectedPlatformAccountTiktokConfigurationModal = ({
  platformName,
  onClose,
  handleFetchConnectedPlatforms,
}) => {
  const [tiktokAdsAccountId, setTiktokAdsAccountId] = useState("");
  const [availableTiktokAdsAccountIds, setAvailableTiktokAdsAccountIds] =
    useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Fetch selected TikTok Ads Account ID
    const fetchTiktokData = async () => {
      try {
        const response = await getRequest(
          "/api/ads/tiktok/fetch-tiktok-ads-account"
        );

        const responseData = response.data;

        if (responseData?.tiktok_ads_advertiser_id) {
          setTiktokAdsAccountId(responseData.tiktok_ads_advertiser_id);
        }

        if (Array.isArray(responseData?.advertiser_ids)) {
          setAvailableTiktokAdsAccountIds(responseData.advertiser_ids);
        }
      } catch (err) {
        console.error("Error fetching TikTok Ads data", err);
        setError("Failed to fetch TikTok Ads data.");
      }
    };

    fetchTiktokData();
  }, []);

  const saveTiktokAccessToken = async () => {
    if (!tiktokAdsAccountId) {
      setError("Please select a TikTok Ads Account ID.");
      return;
    }

    try {
      setLoading(true);
      setError(null);

      await postRequest(
        "/api/ads/tiktok/save-tiktok-ads-account",
        { tiktoksAdvertisorId: tiktokAdsAccountId }
      );

      toast.success("TikTok Ads Account updated successfully!");
      onClose();
      handleFetchConnectedPlatforms();
    } catch (err) {
      console.error(err);
      setError("An error occurred while saving the TikTok Ads account.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {/* TikTok Ads Account Selection */}
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            TikTok Ads Account ID
          </label>
          <select
            value={tiktokAdsAccountId}
            onChange={(e) => setTiktokAdsAccountId(e.target.value)}
            className="mt-1 p-2 w-full border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none z-10"
          >
            <option value="" disabled>
              Select TikTok Account ID
            </option>
            {availableTiktokAdsAccountIds.map((option) => (
              <option key={option} value={option}>
                {`${option}`}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Note/Disclaimer */}
      <div className="text-xs text-gray-500 italic mb-6">
        The ID of your TikTok Ads account
      </div>

      {/* Error Message */}
      {error && <div className="text-red-500 text-sm mb-4">{error}</div>}

      {/* Buttons */}
      <div className="flex justify-end gap-4">
        <button
          onClick={onClose}
          className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300"
        >
          Cancel
        </button>
        <button
          onClick={saveTiktokAccessToken}
          disabled={loading}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400"
        >
          {loading ? "Saving..." : "Save"}
        </button>
      </div>
    </div>
  );
};

export default ConnectedPlatformAccountTiktokConfigurationModal;
